import "./styles.scoped.css";
export default {
    "block-body-scroll": "awsui_block-body-scroll_19d8l_l5x8d_97",
    "mobile-bar": "awsui_mobile-bar_19d8l_l5x8d_101",
    "mobile-bar-breadcrumbs": "awsui_mobile-bar-breadcrumbs_19d8l_l5x8d_115",
    "mobile-toggle": "awsui_mobile-toggle_19d8l_l5x8d_122"
};
